export const redirectedBrandSlugPath = ({ slug, route }) => {
  const brandsSlugMap = new Map([
    ['anastasia', 'anastasia-beverly-hills'],
    ['giorgio-armani', 'armani-beauty'],
    ['armani', 'armani-beauty'],
    ['artis', 'artis-brush'],
    ['beauty-blender', 'beautyblender'],
    ['burberry', 'burberry-beauty'],
    ['dr-dot-jart-plus', 'dr-jart'],
    ['gucci', 'gucci-beauty'],
    ['kopari', 'kopari-beauty'],
    ['lixir', 'lixirskin'],
    ['marc-jacobs-fragrance', 'marc-jacobs-fragrances'],
    ['milk', 'milk-makeup'],
    ['milkshake', 'milk-shake'],
    ['thierry-mugler', 'mugler'],
    ['one-slash-size-beauty', 'one-size'],
    ['slip-silk-pillowcase', 'slip'],
    ['soleil-toujour', 'soleil-toujours'],
    ['star-skin', 'starskin'],
    ['thisworks', 'this-works']
  ])
  const mapped = brandsSlugMap.get(slug)
  if (!mapped || mapped === slug) return

  return route.fullPath.replace(
    new RegExp(`^/brands/${slug}`),
    `/brands/${mapped}`
  )
}
